<template>
  <svg width="72" height="24" viewBox="0 0 72 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M36 20.422L2.44849 0.227392C1.66383 -0.244893 0.664255 0.0422549 0.215883 0.868755C-0.232496 1.69525 0.0401172 2.74812 0.824778 3.22041L34.7822 23.6594C35.5368 24.1135 36.4632 24.1135 37.2178
        23.6594L71.1752 3.22042C71.9599 2.74813 72.2325 1.69526 71.7841 0.868761C71.3357 0.0422611 70.3362 -0.244887 69.5515 0.227398L36 20.422Z"
      fill="white"
    />
  </svg>
</template>
